import { useState } from "react";
import { toast } from "sonner";
import { api, errorMessage } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";

export const ChangePasswordDialog = ({ open, onOpenChange, forced, onDone }) => {
  const [f, setF] = useState({ current: "", new: "", confirm: "" });
  const [busy, setBusy] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    if (f.new !== f.confirm) { toast.error("Le due password nuove non coincidono."); return; }
    setBusy(true);
    try { await api.post("/auth/password/change", { current: f.current, new: f.new }); toast.success("Password aggiornata"); setF({ current: "", new: "", confirm: "" }); onDone?.(); onOpenChange(false); }
    catch (x) { toast.error(errorMessage(x)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={open} onOpenChange={forced ? () => {} : onOpenChange}>
      <DialogContent className={forced ? "sm:max-w-md [&>button]:hidden" : "sm:max-w-md"} data-testid="change-password-dialog" onInteractOutside={(e) => forced && e.preventDefault()}>
        <DialogHeader><DialogTitle>{forced ? "Imposta la tua password" : "Cambia password"}</DialogTitle>
          <DialogDescription>{forced ? "Al primo accesso sostituisci la password temporanea con una tua." : "Almeno 10 caratteri, con lettere e numeri."}</DialogDescription></DialogHeader>
        <form onSubmit={submit} className="space-y-3">
          {[["current", forced ? "Password temporanea" : "Password attuale"], ["new", "Nuova password (min. 10, lettere e numeri)"], ["confirm", "Ripeti la nuova password"]].map(([k, l]) => (
            <div key={k} className="space-y-1.5"><Label className="text-xs">{l}</Label>
              <Input type="password" required minLength={k === "current" ? 1 : 10} value={f[k]} onChange={(e) => setF({ ...f, [k]: e.target.value })} data-testid={`change-password-${k}`} /></div>))}
          <DialogFooter><Button type="submit" disabled={busy} data-testid="change-password-submit">{busy ? "Salvataggio…" : "Salva password"}</Button></DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
};
